import InfiniteTree from './InfiniteTree';

export default InfiniteTree;
